import { Link } from 'react-router-dom'

import ArrowRightFromBracketIcon from '@ui-components-3/icons/lib/solid/ArrowRightFromBracket'
import CircleQuestionIcon from '@ui-components-3/icons/lib/solid/CircleQuestion'
import UserIcon from '@ui-components-3/icons/lib/solid/User'
import Menu from '@ui-components-3/ui/lib/components/Menu'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { useMemo } from 'react'
import User from 'singletons/User'
import { observer } from 'mobx-react-lite'

const AccountMenu = () => {
  const { firstName, lastName } = User.provider || {}

  const initials = useMemo(() => {
    return firstName[0] + lastName[0]
  }, [firstName, lastName])

  const dropdownMenuItems = useMemo(
    () => [
      {
        title: 'Account',
        IconComponent: UserIcon,
        link: '/account',
      },
      {
        title: 'Help Center',
        IconComponent: CircleQuestionIcon,
        link: '/help',
      },
      {
        title: 'Log Out',
        IconComponent: ArrowRightFromBracketIcon,
        action: () => User.logout(),
      },
    ],
    [],
  )

  const avatarClassName =
    'btn-unsized btn-primary bg-primary-800 hover:bg-primary-800 rounded-full w-10 h-10 text-white uppercase flex items-center justify-center text-center text-[20px] mr-4'

  return (
    <Menu
      className={classNames(avatarClassName, 'outline-none')}
      prefix={
        <p className="flex items-center p-3 border-b border-b-neutral-300 typography-body-l">
          <div className={avatarClassName}>{initials}</div>
          {firstName} {lastName}
        </p>
      }
      items={dropdownMenuItems.map(({ IconComponent, title, action, link }) => {
        const content = (
          <>
            <IconComponent className="w-6 h-6 text-neutral-300" />
            {title}
          </>
        )

        if (link) {
          return <Link to={link}>{content}</Link>
        }

        return (
          <button type="button" onClick={action}>
            {content}
          </button>
        )
      })}
      itemClassName="min-w-[250px] flex items-center gap-3 !px-2 typography-body-l my-1"
      aria-label={`Account menu. ${firstName} ${lastName}`}
    >
      {initials}
    </Menu>
  )
}

export default observer(AccountMenu)